import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import InstallmentModal from './installment.dialog';
import CoinsuranceModal from './coinsurance.dialog';

const installement = [
  {
    sl: 1,
    quotationNo: '42012507000000247',
    proposer: 'Town municipal council Bannur',
    policyStartOn: '07 July 2025 12:00 AM',
    policyEndOn: '06 July 2026 12:00 AM',
    ssm: '',
    sp: '0000000024007258',
  },
];

const GeneratePolicy = () => {
  const [filterType, setFilterType] = useState('');
  const [uploadDate, setUploadDate] = useState('');
  const [quotationNo, setQuotationNo] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [openDialogSuccessfull, setOpenDialogSuccessfull] = useState(false);
  const [showComponentInstallment, setShowComponentInstallment] = useState(false);
  const [showComponentCoinsurance, setShowComponentCoinsurance] = useState(false);
  const [policyNo, setPolicyNo] = useState('');
  const [showRackRateDetails, setShowRackRateDetails] = useState(false);
  const handleCreate = () => {
    setOpenDialog(true);
  };

  const sumInsuredValues = [100000, 200000, 300000, 400000, 500000, 600000];
  const ageBands = ['00-25', '26-35', '36-45', '46-55', '56-65', '66-70', '71-75', '76-80', '81-120'];

  const rackRateData = [
    {
      sumInsured: 100000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 200000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 300000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 400000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 500000,
      rates: ['3973.33', '5464.28', '8313.7', '12497.0', '18637.31', '27642.93', '37320.22', '48991.18', '64171.96'],
    },
    {
      sumInsured: 600000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
  ];

  const memberCountData = [
    { sumInsured: 100000, counts: ['', '', '', '', '', '', '', '', ''] },
    { sumInsured: 200000, counts: ['', '', '', '', '', '', '', '', ''] },
    { sumInsured: 300000, counts: ['', '', '', '', '', '', '', '', ''] },
    { sumInsured: 400000, counts: ['', '', '', '', '', '', '', '', ''] },
    { sumInsured: 500000, counts: [1, '', '', '', '', '', '', '', ''] },
    { sumInsured: 600000, counts: ['', '', '', '', '', '', '', '', ''] },
  ];

  const [values, setValues] = React.useState({
    frequency: 'Annual',
    sez: 'No',
    basic: '3973.33',
    cgst: '357.6',
    sgst: '357.6',
    igst: '0.0',
    tax: '715.2',
    gross: '4688.53',
  });

  //   const handleFilter = () => {
  //     const filtered = installement.filter(row => {
  //       const policyDate = new Date(row.policyStartDate);
  //       const start = startDate ? new Date(startDate) : null;
  //       const end = endDate ? new Date(endDate) : null;

  //       if (start && end) {
  //         return policyDate >= start && policyDate <= end;
  //       } else if (start) {
  //         return policyDate >= start;
  //       } else if (end) {
  //         return policyDate <= end;
  //       }
  //       return true;
  //     });

  //     setFilteredData(filtered);
  //   };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // const handleFileChange = e => {
  //   setSelectedFile(e.target.files[0]);
  // };

  const handleFileChange = event => {
    const file = event.target.files?.[0];
    setSelectedFile(file || null);
  };

  const handleUpload = () => {
    if (!selectedFile) return alert('Please choose a file first.');
    // Add your file upload logic here
    alert(`Uploading: ${selectedFile.name}`);
    setShowRackRateDetails(true);
  };

  const handleDownload = () => {
    // Replace with actual format file URL
    const link = document.createElement('a');
    link.href = '/path/to/sample_format.xlsx';
    link.download = 'sample_format.xlsx';
    link.click();
  };

  // const handleSave = () => {
  //   setOpenDialogSuccessfull(true);
  // };

  const generatePolicyNo = () => {
    const code = 'PN';
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const randomNum = Math.floor(100 + Math.random() * 900); // e.g., 297
    return `${code}${year}${month}${randomNum}`;
  };

  const handleSave = () => {
    const newQuotation = generatePolicyNo();
    setPolicyNo(newQuotation);
    setOpenDialogSuccessfull(true);
  };

  const handleInstallement = () => {
    setShowComponentInstallment(prev => !prev);
  };

  const handleCoinsurance = () => {
    setShowComponentCoinsurance(prev => !prev);
  };

  useEffect(() => {
    // After data is fetched and setInstallement(installementData)
    setFilteredData(installement); // show all by default
  }, [installement]);
  return (
    <Box>
      <Box component={Paper} p={2} mb={2} fontWeight="bold">
        Generate Policy
      </Box>
      <Box display="flex" justifyContent="flex-end" mb={2} mt={2}>
        <Box display="flex" alignItems="flex-end" gap="2rem" style={{ display: 'flex', gap: '1rem' }}>
          {/* Filter Type Dropdown */}
          <Box sx={{ width: 220 }}>
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel id="filter-type-label">Search By</InputLabel>
              <Select
                labelId="filter-type-label"
                label="Filter By"
                value={filterType}
                onChange={e => setFilterType(e.target.value)}>
                <MenuItem value="">Select...</MenuItem>
                <MenuItem value="policy">Quotation Number</MenuItem>
                <MenuItem value="date">Upload Date</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Conditional Inputs */}
          {filterType === 'policy' && (
            <Box>
              <TextField
                label="Quotation Number"
                size="small"
                value={quotationNo}
                onChange={e => setQuotationNo(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          )}

          {filterType === 'date' && (
            <>
              <Box sx={{ minWidth: 160 }}>
                <TextField
                  label="Upload Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={uploadDate}
                  onChange={e => setUploadDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
            </>
          )}

          {/* Search Button with extra margin on Date Range */}
          {filterType && (
            <Box sx={{ ml: filterType === 'date' ? 4 : 2 }}>
              <Button variant="contained" color="primary">
                Search
              </Button>
            </Box>
          )}
        </Box>
      </Box>
      <Box style={{ marginTop: '1rem' }}>
        <TableContainer component={Paper}>
          <Table>
            {' '}
            <TableHead style={{ backgroundColor: '#f5f5f5' }}>
              <TableRow>
                <TableCell>Sl#</TableCell>
                <TableCell>Quotation No</TableCell>
                <TableCell>Proposer</TableCell>
                <TableCell>Policy Start On</TableCell>
                <TableCell>Policy End On</TableCell>
                <TableCell>SSM</TableCell>
                <TableCell>SP</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData?.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.quotationNo}</TableCell>
                  <TableCell>{row.proposer}</TableCell>
                  <TableCell>{row.policyStartOn}</TableCell>
                  <TableCell>{row.policyEndOn}</TableCell>
                  <TableCell>{row.ssm}</TableCell>
                  <TableCell>{row.sp}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      color="primary"
                      sx={{ mt: 0.5, textTransform: 'none' }}
                      onClick={handleCreate}>
                      Create
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Dialog
        open={openDialog}
        fullWidth
        maxWidth="lg"
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: isSmallScreen
            ? {
                margin: 'auto', // center it on small screens
              }
            : {
                position: 'absolute',
                top: 20,
                // left: 300,
                margin: 0,
              },
        }}>
        <DialogTitle id="form-dialog-title">
          <Box component={Paper} p={2} mb={2} fontWeight="bold">
            Create New Policy
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContent>
            {!showRackRateDetails && (
              <Box display="flex" justifyContent="center">
                <Box border={1} borderColor="grey.400" borderRadius={4} padding={3} boxShadow={2}>
                  <Grid container spacing={4} alignItems="center" justifyContent="center">
                    <Grid item xs={12} sm="auto">
                      <Button variant="outlined" color="primary" onClick={handleDownload} style={{ minWidth: 180 }}>
                        DOWNLOAD FORMAT
                      </Button>
                    </Grid>

                    <Grid item xs={12} sm="auto">
                      <Input type="file" onChange={handleFileChange} inputProps={{ accept: '.xlsx,.csv' }} />
                    </Grid>

                    <Grid item xs={12} sm="auto">
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleUpload}
                        disabled={!selectedFile}
                        style={{ minWidth: 100 }}>
                        Upload
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            )}

            {showRackRateDetails && (
              <>
                <Typography style={{ display: 'flex', justifyContent: 'center', color: 'red' }}>
                  Member Count Uploaded Successfully
                </Typography>
                <Box
                  mt={2}
                  display="flex"
                  justifyContent="center"
                  gap={2}
                  flexWrap="nowrap"
                  style={{ display: 'flex', gap: '0.5rem' }}>
                  {/* Rack Rate Details Table */}
                  <Box width="600px">
                    <Typography align="center" variant="subtitle1" gutterBottom>
                      Rack Rate Details
                    </Typography>
                    <TableContainer
                      component={Paper}
                      style={{
                        maxWidth: '100%',
                        overflowX: 'auto',
                        border: '1px solid #ccc',
                        padding: '4px',
                      }}>
                      <Table
                        size="small"
                        style={{
                          fontSize: '10px',
                        }}>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ fontSize: '10px', padding: '4px' }}>
                              <strong>Sum Insured</strong>
                            </TableCell>
                            {ageBands.map((band, idx) => (
                              <TableCell key={idx} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                                <strong>{band}</strong>
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rackRateData.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell style={{ fontSize: '10px', padding: '4px' }}>{row.sumInsured}</TableCell>
                              {row.rates.map((rate, i) => (
                                <TableCell key={i} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                                  {rate}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>

                  {/* Member Count Table */}
                  <Box width="600px">
                    <Typography align="center" variant="subtitle1" gutterBottom>
                      Member Counts
                    </Typography>
                    <TableContainer
                      component={Paper}
                      style={{
                        maxWidth: '100%',
                        overflowX: 'auto',
                        border: '1px solid #ccc',
                        padding: '4px',
                      }}>
                      <Table size="small" style={{ fontSize: '10px' }}>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ fontSize: '10px', padding: '4px' }}>
                              <strong>Sum Insured</strong>
                            </TableCell>
                            {ageBands.map((band, idx) => (
                              <TableCell key={idx} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                                <strong>{band}</strong>
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {memberCountData.map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell style={{ fontSize: '10px', padding: '4px' }}>{row.sumInsured}</TableCell>
                              {row.counts.map((count, i) => (
                                <TableCell key={i} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                                  {count}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
                <Box
                  border={1}
                  borderColor="#00b0f0"
                  borderRadius={2}
                  p={3}
                  maxWidth={500}
                  mx="auto"
                  style={{ marginTop: '1rem' }}>
                  <Grid container spacing={2} alignItems="center">
                    {/* Premium Frequency */}
                    <Grid item xs={6}>
                      <Typography>
                        <span style={{ color: 'red' }}>*</span> Premium Frequency :
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth size="small">
                        <Select
                          value={values.frequency}
                          onChange={e =>
                            setValues(prev => ({
                              ...prev,
                              frequency: e.target.value,
                            }))
                          }>
                          <MenuItem value="Annual">Annual</MenuItem>
                          <MenuItem value="Installment">Installment</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* SEZ */}
                    <Grid item xs={6}>
                      <Typography>
                        <span style={{ color: 'red' }}>*</span> Special Economic Zone :
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl fullWidth size="small">
                        <Select
                          value={values.sez}
                          onChange={e =>
                            setValues(prev => ({
                              ...prev,
                              sez: e.target.value,
                            }))
                          }>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* Fields */}
                    {[
                      { label: 'Basic Premium', key: 'basic' },
                      { label: 'CGST (9%)', key: 'cgst' },
                      { label: 'SGST (9%)', key: 'sgst' },
                      { label: 'IGST (18%)', key: 'igst' },
                      { label: 'Tax Amount', key: 'tax' },
                      { label: 'Gross Premium', key: 'gross' },
                    ].map(field => (
                      <React.Fragment key={field.key}>
                        <Grid item xs={6}>
                          <Typography>
                            <span style={{ color: 'red' }}>*</span> {field.label} :
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField fullWidth size="small" value={values[field.key]} InputProps={{ readOnly: true }} />
                        </Grid>
                      </React.Fragment>
                    ))}

                    {/* Co-Insurer Button */}
                    <Grid item xs={6}></Grid>
                    <Grid item xs={6} style={{ display: 'flex' }}>
                      <Grid item xs={6}>
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ backgroundColor: '#00b0f0', textTransform: 'none' }}
                          style={{ backgroundColor: '#00b0f0' }}
                          onClick={handleCoinsurance}>
                          Co-Insurer
                        </Button>
                      </Grid>
                      {values.frequency === 'Installment' ? (
                        <Grid item xs={6}>
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ backgroundColor: '#00b0f0', textTransform: 'none' }}
                            style={{ backgroundColor: '#00b0f0' }}
                            onClick={handleInstallement}>
                            Installment
                          </Button>
                        </Grid>
                      ) : null}
                    </Grid>
                  </Grid>
                </Box>
              </>
            )}
          </DialogContent>
        </DialogContent>
        <DialogActions>
          {showRackRateDetails && (
            <Button variant="contained" onClick={handleSave} style={{ backgroundColor: '#00b0f0' }}>
              Save
            </Button>
          )}

          <Button
            variant="contained"
            onClick={() => {
              setOpenDialog(false);
              setShowRackRateDetails(false);
              setValues(prev => ({
                ...prev,
                frequency: 'Annual',
              }));
            }}
            style={{
              backgroundColor: '#d32f2f',
              color: 'white',
              marginLeft: '1rem',
            }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openDialogSuccessfull} onClose={() => setOpenDialogSuccessfull(false)}>
        <DialogTitle>Policy Created Successfully</DialogTitle>
        <DialogContent style={{ display: 'flex' }}>
          <Typography variant="body1">Your Policy No:</Typography>
          <Typography variant="h6" color="primary" mt={1}>
            {policyNo}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenDialogSuccessfull(false)}
            color="primary"
            style={{
              backgroundColor: '#d32f2f',
              color: 'white',
              marginLeft: '1rem',
            }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {showComponentInstallment && (
        <InstallmentModal
          showComponentInstallment={showComponentInstallment}
          setShowComponentInstallment={setShowComponentInstallment}
        />
      )}
      {showComponentCoinsurance && (
        <CoinsuranceModal
          showComponentCoinsurance={showComponentCoinsurance}
          setShowComponentCoinsurance={setShowComponentCoinsurance}
        />
      )}
    </Box>
  );
};

export default GeneratePolicy;
